import Package from './package';

class PackageMc extends Package {
  constructor(projectData, priceData, size) {
    super(projectData, priceData, size);
  }
}

export default PackageMc;
